import React from "react";
import { isNullOrUndefined } from "../../common/utils";
import { UserGroupsController } from "./controller";
import ListUserGroups from "./listUserGroups";
import UserGroupDetails from "./userGroupDetails";

function UserGroups({ match }) {
  const { userGroupTypeUniqueName, userGroupUniqueName } = match.params;
  const { isUserGroupFeatureEnabled } = UserGroupsController(userGroupTypeUniqueName);

  return (
    <>
      {isUserGroupFeatureEnabled ? (
        !isNullOrUndefined(userGroupUniqueName) ? (
          <UserGroupDetails
            userGroupUniqueName={userGroupUniqueName}
            userGroupTypeUniqueName={userGroupTypeUniqueName}
          />
        ) : (
          <ListUserGroups userGroupTypeUniqueName={userGroupTypeUniqueName}/>
        )
      ) : null}
    </>
  );
}

export default UserGroups;
